import React, { Component } from 'react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import { Icon } from "semantic-ui-react";
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';
import Summary from './Communities/Summary'
import { connect } from 'react-redux';

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class TeamMapping extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        }
    }

    componentWillMount() {

    }
    openModal() {
        this.setState({ open: true })
    }
    closeModal() {
        this.setState({ open: false })
    }

    render() {

        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>
        return (
            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    <Accordion expandTool={expandTool} horizontal className="practiceFlowResourcePane" enableKeyboardNavigation={false}>
                        <div tabTitle="Role Summary">
                            <div className="acc-header">Role Summary</div>
                            <Summary {...this.props} />
                        </div>
                    </Accordion>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state) {

    return {
        suborgDetails: state.initiatives.suborgDetails,
    };
}

const connectedTeamMapping = connect(mapStateToProps)(TeamMapping);

export default connectedTeamMapping;

